import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
import _ from 'lodash'

class NotificationsComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (_.size(this.props.notifications.notifications) > 0) {
      return <div><Table notifications={this.props.notifications}></Table></div>
    }
    return <div>You do not have any notifications!</div>
  }
}

NotificationsComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  notifications: PropTypes.object.isRequired,
}

export default NotificationsComponent
